import script from "./BottomBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomBar.vue?vue&type=script&setup=true&lang=js"

import "./BottomBar.vue?vue&type=style&index=0&id=4947f6b2&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/endless-projects/blue-jays-ticketfinder/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4947f6b2"]])

export default __exports__